import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useLang } from "../lib/lang";
import { WHATSAPP_NUMBER, WHATSAPP_DISPLAY } from "../lib/content";
import { LogoMark } from "./Logo";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  const links = [
    { to: "/", label: t.nav.home },
    { to: "/about", label: t.nav.about },
    { to: "/classes", label: t.nav.classes },
    { to: "/faqs", label: t.nav.faqs },
    { to: "/contact", label: t.nav.contact },
  ];

  return (
    <footer className="bg-ink text-cream" data-testid="site-footer">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 py-16 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <LogoMark size={44} />
            <span className="font-display text-xl">{t.brand.name}</span>
          </div>
          <p className={`mt-4 max-w-xs text-sm leading-relaxed text-cream/70 ${t === undefined ? "" : ""}`}>
            {t.footer.tagline}
          </p>
        </div>

        <nav aria-label="Footer">
          <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-marigold">{t.footer.linksTitle}</h2>
          <ul className="mt-4 space-y-2.5">
            {links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.to === "/" ? "home" : l.to.slice(1)}`}
                  className="text-sm text-cream/80 transition-colors hover:text-marigold"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-marigold">{t.footer.contactTitle}</h2>
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="mt-4 inline-flex items-center gap-2 rounded-full border border-cream/25 px-5 py-2.5 text-sm font-semibold transition-all hover:border-marigold hover:text-marigold"
          >
            <MessageCircle size={16} />
            {t.footer.whatsapp} {WHATSAPP_DISPLAY}
          </a>
          <p className="mt-4 text-sm text-cream/70">{t.footer.location}</p>
          <p className="mt-6 max-w-xs text-xs leading-relaxed text-cream/50">{t.footer.privacyLine}</p>
        </div>
      </div>

      <div className="border-t border-cream/15">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-5 py-5 text-xs text-cream/50 sm:flex-row">
          <span>© {year} {t.brand.name}</span>
          <span>{t.footer.rights}</span>
        </div>
      </div>
    </footer>
  );
}
